<template>
  <div>
    <span>
      <button
        v-on:click="ilgiliKisiSil()"
        style="border: none; background: none; margin-right: 5px"
      >
        <Icon icon="bi:trash" color="#ea5455" width="25" height="25" />
      </button>

      <button
        v-on:click="ilgiliKisiDuzenle()"
        style="border: none; background: none; margin-right: 5px"
      >
        <Icon icon="akar-icons:edit" color="#7367f0" width="25" height="25" />
      </button>
    </span>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { Icon } from "@iconify/vue2";
export default {
  components: { Icon },
  methods: {
    ilgiliKisiSil() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        IlgiliKisiID: this.params.data.ACTCONTACTID,
      };

      soap.createClient(url, function (err, client) {
        client.INT_DELETE_ILGILI_KISI(args, function (err, result) {
          if (result.INT_DELETE_ILGILI_KISIResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.INT_DELETE_ILGILI_KISIResult);
            vs.notify({
              title: "Müşteri",
              text: "İlgili Kişi silindi.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            vm.$root.$emit("ilgiliKisiListesi");
          } catch (error) {
            vs.notify({
              title: "Müşteri",
              text: "İlgili Kişi silinirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    ilgiliKisiDuzenle() {
      vm.$root.$emit("ilgiliKisiDuzenle", this.params.data.ACTCONTACTID);
    },
  },
};
</script>